<nz-tabset [nzDestroyInactiveTabPane]="true" [(nzSelectedIndex)]="selectedTabIndex">
  <nz-tab nzTitle="Marketing Request">
    <ng-template nz-tab>
      <app-marketing-request (navigateToAllocation)="openAllocationTab()"></app-marketing-request>
    </ng-template>
  </nz-tab>

  <nz-tab nzTitle="Allocation">
    <ng-template nz-tab>
      <app-marketing-quota></app-marketing-quota>
    </ng-template>
  </nz-tab>
</nz-tabset>
